import React from 'react'
import ReactHtmlParser from 'react-html-parser'
import PropTypes from 'prop-types'
import Container from 'react-bootstrap/Container'
import Row from 'react-bootstrap/Row'
import Col from 'react-bootstrap/Col'
import ContentBlock from 'components/atoms/ContentBlock'
import Typography from 'components/atoms/Typography'
import CardInformationIcon from 'components/molecules/CardInformationIcon'
import Anchor from 'components/organisms/Anchor'
import './CoverageArea.scss'

function CoverageArea({ title, description, data, refs }) {
  return (
    <Container className="CoverageArea py-5">
      {title && (
        <Row>
          <Col sm={12} md={12}>
            <ContentBlock>
              <Typography variant="h2" color="primary" cssClass="title-bold-md">
                {title}
              </Typography>
              <div className="description-text mt-2">{ReactHtmlParser(description)}</div>
            </ContentBlock>
          </Col>
        </Row>
      )}
      <Row className="pt-4">
        <Col sm={12} md={12}>
          {data.map(({ entity }, index) =>
            entity.entityBundle === 'anchor' ? (
              <Anchor data={entity} refs={refs} />
            ) : (
              <CardInformationIcon
                icon={entity.icon?.entity.media?.entity.fieldMediaFile?.entity.url}
                text={entity.description?.value}
                theme={entity.theme?.entity?.classes || 'tertiary'}
                title={entity.title}
                key={index}
              />
            )
          )}
        </Col>
      </Row>
    </Container>
  )
}

CoverageArea.propTypes = {
  title: PropTypes.string,
  description: PropTypes.string,
  data: PropTypes.object,
  refs: PropTypes.object,
}

export default CoverageArea
